import i18next from 'i18next';

import { FilterDefinitionType } from 'enums';
import {
  BlockedCustomersFilters,
  FilterDefinition,
  Merchant,
  Shop,
} from 'types';

const getCommonFilters = (
  merchants?: Merchant[],
  shops?: Shop[],
): FilterDefinition<BlockedCustomersFilters>[] => {
  const { t } = i18next;
  const filters: FilterDefinition<BlockedCustomersFilters>[] = [
    {
      label: t('filters.merchant'),
      name: 'merchantId',
      type: FilterDefinitionType.Merchant,
      merchants,
    },
    {
      label: t('filters.shop'),
      name: 'shopId',
      type: FilterDefinitionType.Shop,
      shops,
    },
    {
      label: t('filters.customer'),
      name: 'customerId',
      type: FilterDefinitionType.Text,
    },
  ];
  return filters;
};

export const blockedCustomersUtils = {
  getCommonFilters,
};
